module.exports = __webpack_public_path__ + "img/banner5.42673aef.jpg";